module.exports = __webpack_public_path__ + "media/images/patterns/header-profile-7dc5492d8e0fe236c1f486f894a912c9.png";